<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other"></i>
        新增摄像头
      </div>
    </div>
    <el-form ref="form" :model="form" label-width="110px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="摄像头ip"
            prop="ip"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
          >
            <el-input v-model="form.ip" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="摄像头账号"
            prop="account"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
          >
            <el-input v-model="form.account"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="摄像头密码"
            prop="password"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
          >
            <el-input v-model="form.password" type="password"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            label="摄像头类型"
            prop="type"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
          >
            <el-select v-model="form.type">
              <el-option
                v-for="item in videotype"
                :key="item.mc_css_style"
                :label="item.mc_name"
                :value="item.mc_css_style"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="通道名称">
            <el-input v-model="form.channelName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="btn-box">
        <div class="l-btn" @click="onSubmit">保存</div>
        <div class="l-btn ml20" @click="$router.back()">返回</div>
      </div>
    </el-form>
  </div>
</template>

<script>
// import getLoation from './getLoation'

export default {
  components: {},
  data() {
    return {
      form: {
        ip: "",
        account: "",
        password: "",
        type: "",
        channelName: "", // 通道名称
      },
      videotype: [],
      // infoOpts:["水位","水压","电气火灾监控设备","用户信息传输装置","无线烟感","RTU","其他"],

      rules: {},
    };
  },
  created() {
    this.$post("/devicemanage/mapcode", { mc_parent_id: 215 }).then((res) => {
      console.log(res);
      this.videotype = res.data;
      console.log(this.videotype);
    });
    if (this.$route.query.id) {
      this.$post(`/crt/areadetail/${this.$route.query.id}`).then((res) => {
        this.form = res.data;
        if (res.data.image_name) {
          this.fileList.push({ name: "图片" + 1, url: res.data.image_name });
        }
      });
    }
  },
  methods: {
    //上传

    onSubmit() {
      this.$refs.form.validate((valid) => {
        // console.log(this.form);
        if (valid) {
          this.save();
        } else {
          return false;
        }
      });
    },
    save() {
      let loading = this.$loading({ background: "rgba(0, 0, 0, 0.6)" });
      //   let api = this.$route.query.id ? "/crt/areaupdate" : "/crt/areainsert";
      this.$get("/camera/api/add", this.form)
        .then((res) => {
          if (res.status==0) {
            console.log(this.form.channelName);
            if (this.form.channelName) {
              var obj = {
                ip: this.form.ip,
                channelName: this.form.channelName,
              };
              this.$get("/camera/api/addChannel", obj).then((Res) => {
                // this.$message.success("保存成功");
                this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
                this.$router.back();
                loading.close();
              });
            }else{
                  //  this.$message.success("保存成功");
                   this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
            this.$router.back();
            loading.close();
            }
          } else {
              this.$message.error(res.errorMsg)
            loading.close();

          }
          //   this.$message.success("保存成功");
        })
        .catch((err) => {
          loading.close();
        });
    },
  },
};
</script>

<style scoped>
</style>
